import React, { FunctionComponent } from 'react';
import { Config, withConfig } from '@browsing/config';
import { Campaign } from '@shared/types/mylounge';
import { useDeliveryFlagVariant } from '@shared/abtests';
import SpecialBanner from '@client/components/shared/SpecialBanner';

import CampaignInfo from './campaign-info';
import DeliveryLabel from './DeliveryLabel';
import * as S from './campaign-label.styles';

const SHORTEN_DELIVERY = 'event_delivery_promise_shortend_delivery';

interface Props {
    hoverClassName?: string;
    campaign: Campaign;
    categorySubline: string[];
    config: Config;
    showDeliveryLabel: boolean;
    isSpecialDeliveryBanner: boolean;
}

export const CampaignLabel: FunctionComponent<Props> = ({
    campaign,
    hoverClassName,
    categorySubline,
    config,
    isSpecialDeliveryBanner,
    showDeliveryLabel,
}) => {
    const shortenDelivery = campaign?.deliveryPromise?.type === SHORTEN_DELIVERY;
    const isNewFastDeliveryFlag: boolean = useDeliveryFlagVariant();
    const specificDeliveryTimeText =
        config.isEnabled('shortDeliveryText') && shortenDelivery
            ? 'campaigns.specificDeliveryTime'
            : null;

    return (
        <S.Container>
            {showDeliveryLabel && !isNewFastDeliveryFlag && (
                <DeliveryLabel
                    message={campaign.deliveryPromise.text}
                    translationId={specificDeliveryTimeText}
                    // TODO: Move me here.
                    hoverClassName={hoverClassName}
                />
            )}
            {isSpecialDeliveryBanner && <SpecialBanner promise={campaign.deliveryPromise} />}
            <S.Title>
                <span>{campaign.name}</span>
            </S.Title>
            <CampaignInfo campaign={campaign} categorySubline={categorySubline} />
        </S.Container>
    );
};

export default withConfig(CampaignLabel);
